import React from 'react'
import { Grid, Typography } from '@mui/material'
import {
  CustomContainedButton,
  CustomOutlinedButton,
  Translate,
  TurnDocument,
} from '@innovatrics/checkin-components'

import { Steps } from '../views'

interface ScanFrontPageConfirmProps {
  setStep: React.Dispatch<React.SetStateAction<Steps>>
  skipBackPage: () => void
}

export const ScanFrontPageConfirm = ({
  setStep,
  skipBackPage,
}: ScanFrontPageConfirmProps) => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      flexDirection={'column'}
    >
      <TurnDocument />
      <Typography variant="h3" align="center">
        <Translate
          entityName={'customer.nextPageConfirm.title'}
          defaultMessage={
            'Please, turn your document.<br>We need your back side.'
          }
        />
      </Typography>
      <Grid item>
        <Grid
          container
          alignItems={'center'}
          justifyContent={'center'}
          marginTop={'30px'}
          flexDirection={'row'}
        >
          <CustomOutlinedButton
            onClick={skipBackPage}
            variant="outlined"
            color="primary"
            sx={{ width: 'auto' }}
          >
            <Translate
              entityName={'customer.nextPageConfirm.button.skip'}
              defaultMessage={'Skip'}
            />
          </CustomOutlinedButton>
          <div style={{ padding: '10px' }} />
          <CustomContainedButton
            onClick={() => setStep(Steps.SCAN_DOCUMENT_BACK_PAGE)}
            variant="contained"
            color="primary"
            sx={{ width: 'auto' }}
          >
            <Translate
              entityName={'customer.nextPageConfirm.button.continue'}
              defaultMessage={'Continue'}
            />
          </CustomContainedButton>
        </Grid>
      </Grid>
    </Grid>
  )
}
